import React from 'react'
import reportStyles from './PDFReportStyles';    
import { pdf, Document, Text, Page, View, Image } from '@react-pdf/renderer'

const OralRiskPage = (params) => {
   
  const entity = params.entity;
  const reportParams = params.params;  

  return (

<Page size="A4" style={reportStyles.page}>
    <View style={reportStyles.HeaderContainer}>
        <Image src={process.env.PUBLIC_URL + '/images/OralRiskHeader.jpg'}  style={reportStyles.headerImage}/>                                                 
        <Text style={reportStyles.PageTitle}>Oral Risk Assessment</Text>                    
    </View>                            
    <View style={reportStyles.CenterContainerStart}>    
        <View style={reportStyles.table}>
            <View style={reportStyles.rowPageSubHeader}>
                <View style={reportStyles.cell40NB}>
                    <Text style={reportStyles.PageSubTitle}>Overall Assessment</Text>
                </View>
                <View style={reportStyles.cell60NB}>
                    <Image src={process.env.PUBLIC_URL + '/images/Red75Ind.png'} style={reportStyles.imageIndCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Decay Risk & Treatment Need</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/ToothDecay.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/Red75Ind.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Gums and Oral Hygiene</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/GumsHygiene.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/GreenMidInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell50}>
                    <Text style={reportStyles.PageText}>Mal Occlusion Status</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Occlusion.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeLowInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
                <View style={reportStyles.cell50BB}>
                    <Text style={reportStyles.PageText}>Dental Fluorosis Status</Text>
                    <Image src={process.env.PUBLIC_URL + '/images/Fluorosis.png'} style={reportStyles.image100Cell}/> 
                    <Image src={process.env.PUBLIC_URL + '/images/GreenLowInd.png'} style={reportStyles.imageIndCenterCell}/>                                                 
                </View>
            </View>
            <View style={reportStyles.row}>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageText}>Need For Consultation</Text>
                </View>
                <View style={reportStyles.cell20}>
                    <Image src={process.env.PUBLIC_URL + '/images/OrangeCheck.png'} style={reportStyles.image33Cell}/> 
                </View>
                <View style={reportStyles.cell40}>
                    <Text style={reportStyles.PageText}>Recommended*</Text>
                </View>
            </View>
        </View>                                   
    </View>                            
    <View style={reportStyles.FooterContainerSmall}>
        <Text style={reportStyles.footer}>*Indicates if it is apparent that a consultation with a Dentist within a short period of time could be
useful in improving the oral health wellbeing of the child. Factors considered are based on the
National Oral Health Survey and Flouride Mapping (2002 -03) carried out by the Dental Council of
India.
        </Text>
    </View>                            
    </Page>                       

  )          
}
  
export default OralRiskPage